export default "__VITE_ASSET__YDxbA9Gb__"